import { memo } from "react";

import { Card, Group, Stack, Text } from "@mantine/core";
import { PieChart } from "@mantine/charts";

export type DisplayPieChartProps = {
  title: string;
  valueType: "value" | "percent";
  data: Array<{
    name: string;
    value: number;
    color: string;
  }>;
};

const DisplayPieChart = (props: DisplayPieChartProps) => {
  const { title, valueType, data } = props;

  return (
    <Card withBorder h={280} shadow="xs">
      <Stack gap={0} align="center">
        <Group justify="center" align="center" h={50}>
          <Text c="gray.7" size="sm" fw={700}>
            {title}
          </Text>
        </Group>

        <PieChart
          data={data}
          withLabels
          labelsPosition="outside"
          labelColor="gray"
          withTooltip
          labelsType={valueType}
          h={230}
        />
      </Stack>
    </Card>
  );
};

export default memo(DisplayPieChart);
